/* Copyright (c) 2020 IceRock MAG Inc. Use of this source code is governed by the Apache 2.0 license. */

import React, {FC, useCallback, useEffect, useMemo, useRef, useState} from 'react';
import {FormControl, InputLabel, MenuItem, Select} from '@material-ui/core';
import {observer} from 'mobx-react';
import {IEntityFieldProps} from 'icerockdev-admin-toolkit';

type IProps = IEntityFieldProps & {};

const OrderSlotSelect: FC<IProps> = observer(
  ({label, value, handler, error, isEditing, onClick, options}) => {
    // noinspection TypeScriptValidateTypes
    const ref = useRef<HTMLLabelElement>(null);

    const listData = useMemo<Record<string, { id: string, name: string, order: number }>>(
      () => {
        return options && options.referenceData && Object.keys(options.referenceData).map((id) => {
          const item = options.referenceData[id];
          return {
            id,
            name: item?.name ?? "undefined",
            order: item?.order ?? 0
          }
        }).reduce((obj, item) => (
            {...obj, [item.id]: item}),
          {}
        ) || {}
      },
      [options]
    )

    const onChange = useCallback(
      (event) => {
        if (!handler) return;
        handler(event.target.value);
      },
      [value, handler]
    );

    const [labelWidth, setLabelWidth] = useState(0);

    useEffect(() => {
      setLabelWidth((ref.current && ref.current.clientWidth) || 0);
    }, [ref.current]);

    return isEditing ? (
      <FormControl variant="outlined">
        <InputLabel htmlFor={label} error={!!error} style={{whiteSpace: 'nowrap'}} ref={ref}>
          {label}
        </InputLabel>

        <Select
          variant="outlined"
          id={label}
          name={label}
          label={label}
          value={!value ? '' : value}
          onChange={onChange}
          error={!!error}
          inputProps={{className: 'select'}}
          labelWidth={labelWidth}
          style={{minWidth: labelWidth + 40}}
        >
          <MenuItem value="">...</MenuItem>

          {Object.keys(listData)
            .map(id => listData[id])
            .sort((left, right) => left.order > right.order ? 1 : -1)
            .map((item) => (
              <MenuItem key={item.id} value={item.id}>
                {listData[item.id].name}
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    ) : (
      <div onClick={onClick}>
        {(listData[value]?.name) || (
          <div>&nbsp;</div>
        )}
      </div>
    );
  }
);

export {OrderSlotSelect};
